import { ModalConfirmButton } from '@dreryk/react-components';

import { invoiceCreateAccountModalTranslationKeys } from '../../translations';

import { InvoiceCreateAccountFormController } from './form/InvoiceCreateAccountForm.types';
import { useInvoiceAccountCreateCommand } from './InvoiceCreateAccountModalConfirmButton.hooks';

type InvoiceCreateAccountModalConfirmButtonProps = Pick<InvoiceCreateAccountFormController, 'handleSubmit'> & {
   readonly onClose: VoidFunction;
};

export const InvoiceCreateAccountModalConfirmButton = (
   props: InvoiceCreateAccountModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: invoiceCreateAccount } = useInvoiceAccountCreateCommand({
      onSuccess: props.onClose,
   });

   return (
      <ModalConfirmButton
         label={invoiceCreateAccountModalTranslationKeys.confirmAndCreateAccount}
         onClick={props.handleSubmit(invoiceCreateAccount)}
         blockingOperation={invoiceCreateAccountModalTranslationKeys.creatingAccount}
      />
   );
};
